/**
 * @generated SignedSource<<7557ae8e24b89f939cd4a4e596db471e>>
 * @relayHash f31f94a8b79b364e4520737728ebc705
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f4247d97aeb02b743e62049842937af450e0473c8526e03a78ba577acb28fad7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f4247d97aeb02b743e62049842937af450e0473c8526e03a78ba577acb28fad7",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
